module.exports = __webpack_public_path__ + "img/hill.189ce26a.png";